import gql from "graphql-tag";

export default gql`
  query CoursesNoPlaybackQuery {
    courses {
      totalCount
      nodes {
        objectId
        name
        description
        slug
        cover {
          width
          height
          url
        }
        modules {
          objectId
          name
          description
          lessons {
            objectId
            title
            description
            media {
              ... on CloudflareBlackVideo {
                durationInSeconds
                chapters {
                  title
                  formattedStartTime
                  startTime
                }
              }
              ... on VdoCipherBlackVideo {
                durationInSeconds
                chapters {
                  title
                  formattedStartTime
                  startTime
                }
              }
            }
          }
        }
      }
    }
  }
`;
